import {
  CheckCircle,
  CheckCircleOutline,
  DateRange,
  DragIndicator,
  Edit,
} from "@material-ui/icons";
import PersonIcon from "@material-ui/icons/Person";
import "bootstrap-daterangepicker/daterangepicker.css";
import "../../../assets/styles/selectSearch.css";
import moment from "moment";
import React, { Component } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { getAllContigencyAction } from "../../../actions/MasterTemplateActions";
import {
  getContactsActions,
  getUserRolesAction,
  getallpermissions,
  getContactsActionsByTransactionid,
  getContactsActionsByContactid,
} from "../../../actions/UserActions";
import { getVendorTransactionsAction } from "../../../actions/VendorTransactionActions";
import { updateTransactionDataAction } from "../../../actions/TransactionActions";

// import DatePicker from 'react-date-picker';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AddContact from "../../Contacts/CreateContactNew";
import { Link } from "react-router-dom";
import $ from "jquery";
import {
  convertTimeToMinutes,
  cryptoTokenDecode,
  getContingencyData,
  getTimeFromMins,
  toastMessage,
} from "./../../Common/Common";
import * as code from "./../../../config/Constants";
import * as message from "./../../../config/CommonMessages";
import SelectSearch from "react-select-search";
import SelectClientOrArtist from "./SelectClientOrArtist";
import Fuse from "fuse.js";
import Tasks from "./Tasks";
import { REACT_APP_CRYPTO_SECRET_KEY } from "../../../config/Constants";
var CryptoJS = require("crypto-js");

var _ = require("lodash");

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 3;

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: "none",
  background: isDragging ? "#f5f9fc" : "",
  ...draggableStyle,
});

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "#fff" : "",
});

class UpdateContingencies extends Component {
  constructor(props) {
    super(props);
    var userType = cryptoTokenDecode().usertype;
    let currentType = cryptoTokenDecode().roleName;
    this.state = {
      propsConti: this.props.contingencies,
      show: false,
      show1: false,
      role: "",
      value: "",
      callbyvalue: {},
      roleForGaurdian: "",
      dataOfChildIndex: "",
      dataOfChild: "",
      dataOfChildArtist: "",
      dataOfChildClient: "",
      dataOfChildGaurdian: "",
      contengency: [],
      startDate: moment(),
      closeDate: moment(),
      contStartDate: moment(),
      contEndDate: moment(),
      activeContigency: true,
      inactiveContiClass: "",
      items: [],
      addVendor: false,
      addContingency: false,
      addParticipant: false,
      isVendorClick: false,
      isContiClick: false,
      isPartiClick: false,
      allContingencies: [],
      campContingencies: [],
      allContingenciesFromAPI: [],
      trasactioncontigency: [],
      vendors: [],
      isUpdateConti: false,
      date: new Date(),
      userType: userType.toUpperCase(),
      currentRole: !!currentType ? currentType.toUpperCase() : "",
      isContiExist: false,
      showLoader: false,
      buyerVendors: [],
      artist: this.props.getTransactionData().listingAgents,
      guardian: this.props.getTransactionData().closingAgents,
      client: this.props.getTransactionData().buyers,
      contacts: this.props.contacts,
      openTaskDetail: false,
      editTask: "",
      taskId: "",
      tasks: [],
      loaderArray: [],
      permissionArray: [],
      selectedDuration: "60",
      contactids: [],
    };
    this.onDragEnd = this.onDragEnd.bind(this);
    this.addCloseVendor = this.addCloseVendor.bind(this);

    this.listVendorsByConti = this.listVendorsByConti.bind(this);
  }

  onChange = (date) => this.setState({ date });

  onDragEnd(result) {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );

    this.setState({
      items,
    });
  }

  setModalOpen() {
    this.setState({ show: !this.state.show });
  }

  DataOfChild = (item, roleofchild) => {
    // console.log("full contactssssssss", item);
    // console.log("roleofchild", roleofchild);
    //  console.log("kjxvkc=============>",this.state.roleForGaurdian)

    this.setState({ role: roleofchild });
    //  console.log("role ===>", this.state.role)

    this.setState({ dataOfChild: item._id });
    this.setState({ show1: !this.state.show1 });

    if (this.props.isUpdateTrans) {
      this.setAssignee(
        item._id,
        this.state.callbyvalue.item,
        this.state.callbyvalue.key,
        this.state.callbyvalue.contingencies,
        item
      );
    } else {
      this.getContactsByID([], false, item._id, item);
    }
  };

  setModalOpen1(roleByonclick, value, e_id, itemObject) {
    // console.log("itemobjects",itemObject)
    this.setState({ callbyvalue: itemObject });
    this.setState({ value: value });
    this.setState({ dataOfChild: e_id });
    if (
      roleByonclick == undefined ||
      roleByonclick == "" ||
      roleByonclick == null
    ) {
      this.setState({ role: "" });
      this.setState({ show1: !this.state.show1 });
    } else if (roleByonclick == "Guardian") {
      this.setState({ role: "Client" });
      this.setState({ roleForGaurdian: "Guardian" });
      this.setState({ show1: !this.state.show1 });
    } else {
      // console.log("=======role=======",roleByonclick)
      this.setState({ role: roleByonclick });
      this.setState({ roleForGaurdian: roleByonclick });
      this.setState({ show1: !this.state.show1 });
    }
  }

  /**
   * @desc hide/show add vendor modal
   */
  addVendor() {
    this.setState({ addVendor: !this.state.addVendor, isUpdateConti: true });
  }

  /**
   * @desc hide/show add contingency modal
   */
  addContingency() {
    this.setState({
      addContingency: !this.state.addContingency,
      isUpdateConti: true,
    });
  }

  /**
   * @desc hide/show add participant modal
   */
  addParticipant() {
    this.setState({
      addParticipant: !this.state.addParticipant,
      isUpdateConti: true,
    });
  }

  getUserPermissions() {
    let usertype = localStorage.getItem("usertype");
    if (usertype === "VENDOR") {
      this.props.getallpermissions().then((res) => {
        if (res.data) {
          localStorage.setItem("otherInfo", res.data);
          this.setState({ permission: res.data });
          let bytes = CryptoJS.AES.decrypt(
            res.data,
            REACT_APP_CRYPTO_SECRET_KEY
          );
          let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
          // console.log("Header ===> decryptedData39", decryptedData);
          let permissionarray = decryptedData.split(",");
          // console.log("Header ===> permissionarray", permissionarray);
          this.setState({ permissionArray: permissionarray });
        }
      });
    }
  }

  checkPermission(checkFor) {
    const hasSome =
      this.state.permissionArray &&
      this.state.permissionArray.length > 0 &&
      checkFor.some((item) => this.state.permissionArray.includes(item));
    return hasSome;
  }

  /**
   * @desc after adding vendor list
   * @param {*} contingencies
   */
  addCloseVendor(contingencies) {
    //this.getAllContactsNew(contingencies, true); //commented due to `this.props.transdata._id` id issue.
    this.setState({ isVendorClick: false, addVendor: !this.state.addVendor });
  }

  /**
   * @desc after adding contingency list
   * @param {*} contingencies
   */
  addCloseContingency(contingencies) {
    this.getAllContactsNew(contingencies, true);
    this.setState({
      isContiClick: false,
      addContingency: !this.state.addContingency,
    });
  }

  /**
   * @desc after adding participant list
   * @param {*} contingencies
   */
  addCloseParticipant(contingencies) {
    this.getAllContactsNew(contingencies, true);
    this.setState({
      isPartiClick: false,
      addParticipant: !this.state.addParticipant,
    });
  }

  /**
   * @desc Get contact(vendor) list of user and group it by contigency
   */
  getAllContacts(contingencies, isRes) {
   // console.log("=======i am here at getall contacts========");
    this.setState({
      showLoader: true,
    });

    if (
      this.state.userType === message.BUYER ||
      this.state.currentRole === message.BUYER ||
      (this.state.userType === message.VENDOR &&
        this.state.currentRole === message.VENDOR) ||
      (this.state.userType === message.VENDOR &&
        this.state.currentRole === message.BUYER)
    ) {
      if (this.props.transID) {
        this.props
          .getContactsActions("buyer", this.props.transID)
          .then((res) => {
            let contactsdata = res.data.data;
            let farray = contactsdata.filter((obj, pos, arr) => {
              return (
                arr.map((mapObj) => mapObj["_id"]).indexOf(obj["_id"]) === pos
              );
            });
            this.setState({
              buyerVendors: farray,
              showLoader: false,
            });
          });
      }
    } else {
      let rolename = "admin";
      if (this.state.userType === message.VENDOR) {
        rolename = "ep";
        this.props
          .getContactsActions(
            rolename,
            "?id=" + localStorage.getItem("ownerId") + "&rolename=" + rolename
          )
          .then((epContactsRes) => {
            let vendors = {};
            let other = [];
            let all = [];
            let epContacts = this.props.contacts;

            this.props
              .getUserRolesAction("?id=" + localStorage.getItem("ownerId"))
              .then((epCats) => {
                if (epCats) {
                  vendors = _.groupBy(epContacts, function(c) {
                    return !!c.roles ? c.roles[0] : "";
                  });

                  let newEpCats = {};
                  Object.keys(vendors).forEach((epCat) => {
                    let epName = "";
                    let epRoleName = "";
                    for (let x = 0; x < epCats.length; x++) {
                      if (epCats[x]._id === epCat) {
                        epName = epCats[x].contingency;
                        epRoleName = epCats[x].name;
                      }
                    }
                    if (epName !== "" && epName !== undefined) {
                      let epVen = vendors[epCat];
                      for (let y = 0; y < epVen.length; y++) {
                        epVen[y].roleName = epRoleName;
                      }
                      let epData = { epData: epVen, open: true };
                      newEpCats[epName] = epData;
                    } else {
                      let epVen = vendors[epCat];
                      for (let y = 0; y < epVen.length; y++) {
                        all.push(epVen[y]);
                      }
                    }
                  });

                  let otherEpVen = { data: other, open: true };
                  let allEpVen = { data: all, open: true };

                  newEpCats["other"] = otherEpVen;
                  newEpCats["all"] = allEpVen;

                  this.setState({
                    vendors: newEpCats,
                    showLoader: false,
                  });
                }
              });
          });
      }
      this.props
        .getContactsActions(
          rolename,
          this.props.transdata
            ? "?id=" + this.props.transdata.ownerId + "&rolename=" + rolename
            : ""
        )
        .then(
          (res) => {
            var vendors = {};
            let other = [];
            let all = [];

            var response = this.props.contacts;

            this.props
              .getUserRolesAction(
                this.props.transdata
                  ? "?id=" + this.props.transdata.ownerId
                  : ""
              )
              .then((cats) => {
                if (cats) {
                  vendors = _.groupBy(response, function(b) {
                    return !!b.roles ? b.roles[0] : "";
                  });
                  var newCategories = {};
                  Object.keys(vendors).forEach((cat) => {
                    let name = "";
                    let roleName = "";
                    for (let i = 0; i < cats.length; i++) {
                      if (cats[i]._id === cat) {
                        name = cats[i].contingency;
                        roleName = cats[i].name;
                      }
                    }
                    if (name !== "" && name !== undefined) {
                      let ven = vendors[cat];
                      for (let i = 0; i < ven.length; i++) {
                        ven[i].roleName = roleName;
                      }
                      var data = { data: ven, open: true };
                      newCategories[name] = data;
                    } else {
                      let ven = vendors[cat];
                      for (let i = 0; i < ven.length; i++) {
                        ven[i].roleName = roleName;
                        other.push(ven[i]);
                      }
                    }

                    let ven = vendors[cat];
                    for (let i = 0; i < ven.length; i++) {
                      all.push(ven[i]);
                    }
                  });
                  var otherVen = { data: other, open: true };
                  var allVen = { data: all, open: true };

                  newCategories["other"] = otherVen;
                  newCategories["all"] = allVen;
                  this.setState(
                    {
                      vendors: newCategories,
                      showLoader: false,
                    },
                    () => {
                      if (isRes) {
                        if (
                          this.props.contactResponse !== undefined &&
                          this.props.contactResponse !== null
                        ) {
                          let vendors = this.state.vendors;
                          let venData = this.props.contactResponse.data;
                          let updatedKeys = "";
                          contingencies.map((item, index) => {
                            let conti = item.key;

                            // if (conti === message.HOME_INSPECTION || conti === message.RADON_INSPECTION ||
                            //   conti === message.SEPTIC_INSPECTION || conti === message.WOOD_DESTROYING_INSPECTION ||
                            //   conti === message.FINANCING || conti === message.WELL_TEST ||
                            //   conti === message.WATER_TEST || conti === message.LISTING_AGENT ||
                            //   conti === message.CLOSING_AGENT || conti === message.BUYER_AGENT) {

                            if (
                              vendors[conti] !== undefined &&
                              vendors[conti] !== null
                            ) {
                              let vendorsData =
                                vendors[conti].data !== undefined &&
                                vendors[conti].data !== null
                                  ? vendors[conti].data
                                  : [];
                              for (
                                let i = 0, len = vendorsData.length;
                                i < len;
                                i++
                              ) {
                                if (
                                  vendorsData[i].n_id === venData._id &&
                                  (item.assignee == "" ||
                                    item.assignee === undefined)
                                ) {
                                  item.assignee = vendorsData[i].contactId;
                                  item.vendorName =
                                    vendorsData[i].firstname +
                                    "" +
                                    vendorsData[i].lastname;
                                  item.isActive = true;

                                  contingencies[index] = item;
                                  updatedKeys = item.key;
                                }
                              }
                            }
                            // }
                          });

                          let finalInputCont = [];
                          for (let i = 0; i < contingencies.length; i++) {
                            if (contingencies[i].isActive) {
                              if (contingencies[i].assignee !== "") {
                                finalInputCont.push({
                                  name: contingencies[i].key,
                                  startDate: new Date(contingencies[i].start),
                                  endDate: new Date(contingencies[i].end),
                                  assignee: contingencies[i].assignee,
                                  isParticipant: contingencies[i].isParticipant,
                                });
                              } else {
                                finalInputCont.push({
                                  name: contingencies[i].key,
                                  startDate: new Date(contingencies[i].start),
                                  endDate: new Date(contingencies[i].end),
                                  isParticipant: contingencies[i].isParticipant,
                                });
                              }
                            }
                          }
                          if (this.props.isUpdateTrans) {
                            this.props.contiCamp(finalInputCont, updatedKeys);
                            this.setState({ showLoader: false });
                          } else {
                            this.props.contiCamp(finalInputCont);
                            this.setState({ showLoader: false });
                          }
                        }
                      }
                    }
                  );

                  if (!this.props.isUpdateTrans) {
                    this.props.setVendorsFun(newCategories);
                  }
                } else {
                  this.setState({
                    vendors: [],
                    showLoader: false,
                  });
                }
              });
          },
          (error) => {
            this.setState({
              vendors: [],
              showLoader: false,
            });
          }
        );
    }
  }

  getAllContactsNew(contingencies, isRes) {
   // console.log("======= 562  i am here at getall contacts========");
    this.setState({
      showLoader: true,
    });

    if (
      this.state.userType === message.BUYER ||
      this.state.currentRole === message.BUYER ||
      (this.state.userType === message.VENDOR &&
        this.state.currentRole === message.VENDOR) ||
      (this.state.userType === message.VENDOR &&
        this.state.currentRole === message.BUYER)
    ) {
      if (this.props.transID) {
        this.props
          .getContactsActions("buyer", this.props.transID)
          .then((res) => {
            let contactsdata = res.data.data;
            let farray = contactsdata.filter((obj, pos, arr) => {
              return (
                arr.map((mapObj) => mapObj["_id"]).indexOf(obj["_id"]) === pos
              );
            });
            this.setState({
              buyerVendors: farray,
              showLoader: false,
            });
          });
      }
    } else {
      let rolename = "admin";
      if (this.state.userType === message.VENDOR) {
        rolename = "ep";
       
        this.props
          .getContactsActionsByTransactionid(this.props.transdata._id)
          .then((epContactsRes) => {
            let vendors = {};
            let other = [];
            let all = [];
            let epContacts = this.props.contacts;

            this.props
              .getUserRolesAction("?id=" + localStorage.getItem("ownerId"))
              .then((epCats) => {
                if (epCats) {
                  vendors = _.groupBy(epContacts, function(c) {
                    return !!c.roles ? c.roles[0] : "";
                  });

                  let newEpCats = {};
                  Object.keys(vendors).forEach((epCat) => {
                    let epName = "";
                    let epRoleName = "";
                    for (let x = 0; x < epCats.length; x++) {
                      if (epCats[x]._id === epCat) {
                        epName = epCats[x].contingency;
                        epRoleName = epCats[x].name;
                      }
                    }
                    if (epName !== "" && epName !== undefined) {
                      let epVen = vendors[epCat];
                      for (let y = 0; y < epVen.length; y++) {
                        epVen[y].roleName = epRoleName;
                      }
                      let epData = { epData: epVen, open: true };
                      newEpCats[epName] = epData;
                    } else {
                      let epVen = vendors[epCat];
                      for (let y = 0; y < epVen.length; y++) {
                        all.push(epVen[y]);
                      }
                    }
                  });

                  let otherEpVen = { data: other, open: true };
                  let allEpVen = { data: all, open: true };

                  newEpCats["other"] = otherEpVen;
                  newEpCats["all"] = allEpVen;

                  this.setState({
                    vendors: newEpCats,
                    showLoader: false,
                  });
                }
              });
          });
      }
      //console.log('651 this.props.transdata._id ===>',this.props.transdata._id);
      this.props
        .getContactsActionsByTransactionid(this.props.transdata._id)
        .then(
          (res) => {
            var vendors = {};
            let other = [];
            let all = [];

            //console.log('660 =====================this.props.contacts',this.props.contacts);

            var response = this.props.contacts;

            //console.log('661=====================response',response);

            this.props
              .getUserRolesAction(
                this.props.transdata
                  ? "?id=" + this.props.transdata.ownerId
                  : ""
              )
              .then((cats) => {
                //console.log('668=====================cats',cats);
                if (cats) {
                  vendors = _.groupBy(response, function(b) {
                    return !!b.roles ? b.roles[0] : "";
                  });
                  //console.log('672======vendors', vendors);
                  var newCategories = {};
                  Object.keys(vendors).forEach((cat) => {
                    let name = "";
                    let roleName = "";
                    for (let i = 0; i < cats.length; i++) {
                      if (cats[i]._id === cat) {
                        name = cats[i].contingency;
                        roleName = cats[i].name;
                      }
                    }
                    if (name !== "" && name !== undefined) {
                      let ven = vendors[cat];
                      for (let i = 0; i < ven.length; i++) {
                        ven[i].roleName = roleName;
                      }
                      var data = { data: ven, open: true };
                      newCategories[name] = data;
                    } else {
                      let ven = vendors[cat];
                      //console.log('692======ven', ven);
                      for (let i = 0; i < ven.length; i++) {
                        if(ven[i].roleName){
                          ven[i].roleName = roleName;
                          other.push(ven[i]);
                        }
                      }
                    }

                    let ven = vendors[cat];
                    for (let i = 0; i < ven.length; i++) {
                      all.push(ven[i]);
                    }
                  });
                  var otherVen = { data: other, open: true };
                  var allVen = { data: all, open: true };

                  newCategories["other"] = otherVen;
                  newCategories["all"] = allVen;
                  this.setState(
                    {
                      vendors: newCategories,
                      showLoader: false,
                    },
                    () => {
                      if (isRes) {
                        if (
                          this.props.contactResponse !== undefined &&
                          this.props.contactResponse !== null
                        ) {
                          let vendors = this.state.vendors;
                          let venData = this.props.contactResponse.data;
                          let updatedKeys = "";
                          contingencies.map((item, index) => {
                            let conti = item.key;

                            // if (conti === message.HOME_INSPECTION || conti === message.RADON_INSPECTION ||
                            //   conti === message.SEPTIC_INSPECTION || conti === message.WOOD_DESTROYING_INSPECTION ||
                            //   conti === message.FINANCING || conti === message.WELL_TEST ||
                            //   conti === message.WATER_TEST || conti === message.LISTING_AGENT ||
                            //   conti === message.CLOSING_AGENT || conti === message.BUYER_AGENT) {

                            if (
                              vendors[conti] !== undefined &&
                              vendors[conti] !== null
                            ) {
                              let vendorsData =
                                vendors[conti].data !== undefined &&
                                vendors[conti].data !== null
                                  ? vendors[conti].data
                                  : [];
                              for (
                                let i = 0, len = vendorsData.length;
                                i < len;
                                i++
                              ) {
                                if (
                                  vendorsData[i].n_id === venData._id &&
                                  (item.assignee == "" ||
                                    item.assignee === undefined)
                                ) {
                                  item.assignee = vendorsData[i].contactId;
                                  item.vendorName =
                                    vendorsData[i].firstname +
                                    "" +
                                    vendorsData[i].lastname;
                                  item.isActive = true;

                                  contingencies[index] = item;
                                  updatedKeys = item.key;
                                }
                              }
                            }
                            // }
                          });

                          let finalInputCont = [];
                          for (let i = 0; i < contingencies.length; i++) {
                            if (contingencies[i].isActive) {
                              if (contingencies[i].assignee !== "") {
                                finalInputCont.push({
                                  name: contingencies[i].key,
                                  startDate: new Date(contingencies[i].start),
                                  endDate: new Date(contingencies[i].end),
                                  assignee: contingencies[i].assignee,
                                  isParticipant: contingencies[i].isParticipant,
                                });
                              } else {
                                finalInputCont.push({
                                  name: contingencies[i].key,
                                  startDate: new Date(contingencies[i].start),
                                  endDate: new Date(contingencies[i].end),
                                  isParticipant: contingencies[i].isParticipant,
                                });
                              }
                            }
                          }
                          if (this.props.isUpdateTrans) {
                            this.props.contiCamp(finalInputCont, updatedKeys);
                            this.setState({ showLoader: false });
                          } else {
                            this.props.contiCamp(finalInputCont);
                            this.setState({ showLoader: false });
                          }
                        }
                      }
                    }
                  );

                  if (!this.props.isUpdateTrans) {
                    this.props.setVendorsFun(newCategories);
                  }
                } else {
                  this.setState({
                    vendors: [],
                    showLoader: false,
                  });
                }
              });
          },
          (error) => {
            this.setState({
              vendors: [],
              showLoader: false,
            });
          }
        );
    }
  }

  getContactsByID(contingencies, isRes, id, item) {
    let contactarray = [...this.state.contactids, id];
    //console.log("=======i am here at getall contacts by Id========");
    this.setState({
      showLoader: true,
      contactids: contactarray,
    });

    if (
      this.state.userType === message.BUYER ||
      this.state.currentRole === message.BUYER ||
      (this.state.userType === message.VENDOR &&
        this.state.currentRole === message.VENDOR) ||
      (this.state.userType === message.VENDOR &&
        this.state.currentRole === message.BUYER)
    ) {
      if (this.props.transID) {
        this.props.getContactsActionsByContactid(contactarray).then((res) => {
          let contactsdata = res.data.data;
          let farray = contactsdata.filter((obj, pos, arr) => {
            return (
              arr.map((mapObj) => mapObj["_id"]).indexOf(obj["_id"]) === pos
            );
          });
          this.setState({
            buyerVendors: farray,
            showLoader: false,
          });
        });
      }
    } else {
      let rolename = "admin";
      if (this.state.userType === message.VENDOR) {
        rolename = "ep";
        this.props
          .getContactsActionsByContactid(contactarray)
          .then((epContactsRes) => {
            let vendors = {};
            let other = [];
            let all = [];
            let epContacts = this.props.contacts;

            this.props
              .getUserRolesAction("?id=" + localStorage.getItem("ownerId"))
              .then((epCats) => {
                if (epCats) {
                  vendors = _.groupBy(epContacts, function(c) {
                    return !!c.roles ? c.roles[0] : "";
                  });

                  let newEpCats = {};
                  Object.keys(vendors).forEach((epCat) => {
                    let epName = "";
                    let epRoleName = "";
                    for (let x = 0; x < epCats.length; x++) {
                      if (epCats[x]._id === epCat) {
                        epName = epCats[x].contingency;
                        epRoleName = epCats[x].name;
                      }
                    }
                    if (epName !== "" && epName !== undefined) {
                      let epVen = vendors[epCat];
                      for (let y = 0; y < epVen.length; y++) {
                        epVen[y].roleName = epRoleName;
                      }
                      let epData = { epData: epVen, open: true };
                      newEpCats[epName] = epData;
                    } else {
                      let epVen = vendors[epCat];
                      for (let y = 0; y < epVen.length; y++) {
                        all.push(epVen[y]);
                      }
                    }
                  });

                  let otherEpVen = { data: other, open: true };
                  let allEpVen = { data: all, open: true };

                  newEpCats["other"] = otherEpVen;
                  newEpCats["all"] = allEpVen;

                  this.setState({
                    vendors: newEpCats,
                    showLoader: false,
                  });
                }
              });
          });
      }

      this.props.getContactsActionsByContactid(contactarray).then(
        (res) => {
          var vendors = {};
          let other = [];
          let all = [];

          var response = this.props.contacts;

          this.props
            .getUserRolesAction(
              this.props.transdata ? "?id=" + this.props.transdata.ownerId : ""
            )
            .then((cats) => {
              if (cats) {
                vendors = _.groupBy(response, function(b) {
                  return !!b.roles ? b.roles[0] : "";
                });
                var newCategories = {};
                Object.keys(vendors).forEach((cat) => {
                  let name = "";
                  let roleName = "";
                  for (let i = 0; i < cats.length; i++) {
                    if (cats[i]._id === cat) {
                      name = cats[i].contingency;
                      roleName = cats[i].name;
                    }
                  }
                  if (name !== "" && name !== undefined) {
                    let ven = vendors[cat];
                    for (let i = 0; i < ven.length; i++) {
                      ven[i].roleName = roleName;
                    }
                    var data = { data: ven, open: true };
                    newCategories[name] = data;
                  } else {
                    let ven = vendors[cat];
                    for (let i = 0; i < ven.length; i++) {
                      ven[i].roleName = roleName;
                      other.push(ven[i]);
                    }
                  }

                  let ven = vendors[cat];
                  for (let i = 0; i < ven.length; i++) {
                    all.push(ven[i]);
                  }
                });
                var otherVen = { data: other, open: true };
                var allVen = { data: all, open: true };

                newCategories["other"] = otherVen;
                newCategories["all"] = allVen;
                this.setState(
                  {
                    vendors: newCategories,
                    showLoader: false,
                  },
                  () => {
                    if (isRes) {
                      if (
                        this.props.contactResponse !== undefined &&
                        this.props.contactResponse !== null
                      ) {
                        let vendors = this.state.vendors;
                        let venData = this.props.contactResponse.data;
                        let updatedKeys = "";
                        contingencies.map((item, index) => {
                          let conti = item.key;

                          // if (conti === message.HOME_INSPECTION || conti === message.RADON_INSPECTION ||
                          //   conti === message.SEPTIC_INSPECTION || conti === message.WOOD_DESTROYING_INSPECTION ||
                          //   conti === message.FINANCING || conti === message.WELL_TEST ||
                          //   conti === message.WATER_TEST || conti === message.LISTING_AGENT ||
                          //   conti === message.CLOSING_AGENT || conti === message.BUYER_AGENT) {

                          if (
                            vendors[conti] !== undefined &&
                            vendors[conti] !== null
                          ) {
                            let vendorsData =
                              vendors[conti].data !== undefined &&
                              vendors[conti].data !== null
                                ? vendors[conti].data
                                : [];
                            for (
                              let i = 0, len = vendorsData.length;
                              i < len;
                              i++
                            ) {
                              if (
                                vendorsData[i].n_id === venData._id &&
                                (item.assignee == "" ||
                                  item.assignee === undefined)
                              ) {
                                item.assignee = vendorsData[i].contactId;
                                item.vendorName =
                                  vendorsData[i].firstname +
                                  "" +
                                  vendorsData[i].lastname;
                                item.isActive = true;

                                contingencies[index] = item;
                                updatedKeys = item.key;
                              }
                            }
                          }
                          // }
                        });

                        let finalInputCont = [];
                        for (let i = 0; i < contingencies.length; i++) {
                          if (contingencies[i].isActive) {
                            if (contingencies[i].assignee !== "") {
                              finalInputCont.push({
                                name: contingencies[i].key,
                                startDate: new Date(contingencies[i].start),
                                endDate: new Date(contingencies[i].end),
                                assignee: contingencies[i].assignee,
                                isParticipant: contingencies[i].isParticipant,
                              });
                            } else {
                              finalInputCont.push({
                                name: contingencies[i].key,
                                startDate: new Date(contingencies[i].start),
                                endDate: new Date(contingencies[i].end),
                                isParticipant: contingencies[i].isParticipant,
                              });
                            }
                          }
                        }
                        if (this.props.isUpdateTrans) {
                          this.props.contiCamp(finalInputCont, updatedKeys);
                          this.setState({ showLoader: false });
                        } else {
                          this.props.contiCamp(finalInputCont);
                          this.setState({ showLoader: false });
                        }
                      }
                    }
                  }
                );

                if (!this.props.isUpdateTrans) {
                  this.props.setVendorsFun(newCategories);
                }
                this.setAssignee(
                  id,
                  this.state.callbyvalue.item,
                  this.state.callbyvalue.key,
                  this.state.callbyvalue.contingencies,
                  item
                );
              } else {
                this.setState({
                  vendors: [],
                  showLoader: false,
                });
              }
            });
        },
        (error) => {
          this.setState({
            vendors: [],
            showLoader: false,
          });
        }
      );
    }
  }

  componentDidMount() {
    if (this.props.isUpdateTrans) {
      this.getAllContactsNew([], false);
    }

    this.getUserPermissions();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.transID !== this.props.transID) {
      this.getAllContactsNew([], false);
    }
  }

  componentWillMount() {
    if (this.props.isMasterTemplate) {
      let contingencies = [];
      for (let key in this.props.contingencies) {
        if (this.props.contingencies.hasOwnProperty(key)) {
          contingencies.push({
            key: this.props.contingencies[key].name,
            name: this.props.contingencies[key].name,
            val: this.props.contingencies[key].val,
            isParticipant: Boolean(this.props.contingencies[key].isParticipant),
            isActive: true,
          });
        }
      }
      this.props.getAllContigencyAction().then((res) => {
        res.forEach((ele) => {
          var found = false;
          for (let key in this.props.contingencies) {
            if (ele.name == this.props.contingencies[key].name) {
              found = true;
            }
          }
          if (!found) {
            contingencies.push({
              key: ele.name,
              val: ele.date,
              isParticipant: ele.isParticipant,
              isActive: false,
            });
          }
        });
        this.setState({
          allContingencies: contingencies,
          allContingenciesFromAPI: res,
        });
      });
      this.setState({ allContingencies: contingencies });
    } else {
      let contingencies = [];
      if (this.props.isUpdateTrans) {
        let transcationAllData = this.props.getTransactionData();
        for (let key in this.props.campContingencies) {
          let v = this.props.campContingencies[key];

          contingencies.push({
            key: v.name,
            val: v.name,
            isActive: true,
            isParticipant: v.isParticipant,
            start:
              v.startDate != "" ? v.startDate : this.props.transdata.startDate,
            end: v.endDate != "" ? v.endDate : this.props.transdata.endDate,
            assignee: v.assignee,
            defaultAssignee:
              v.assignee !== "" && v.assignee !== undefined ? false : true,
          });
        }

        this.props.getAllContigencyAction().then((res) => {
          this.setState({ allContingenciesFromAPI: res });
        });
        this.props.updateTransactionData("contingencies", contingencies);
      } else {
        let contingencies = [];
        if (!this.props.isDrafted) {
          for (let key in this.props.campContingencies) {
            if (this.props.campContingencies.hasOwnProperty(key)) {
              contingencies.push({
                key: this.props.campContingencies[key].name,
                name: this.props.campContingencies[key].name,
                val: this.props.campContingencies[key].val,
                isParticipant: Boolean(
                  this.props.campContingencies[key].isParticipant
                ),
                isActive: true,
                start: this.state.contStartDate.format("YYYY-MM-DD"),
                end: this.state.contEndDate.format("YYYY-MM-DD"),
                assignee: "",
              });
            }
          }
        } else {
          contingencies = this.props.campContingencies;
        }
        this.props.getAllContigencyAction().then((res) => {
          this.setState({ allContingenciesFromAPI: res });
        });
        this.props.updateTransactionData("contingencies", contingencies);
      }
    }
  }

  //Change start date of contingency
  contStartDateChanges(date, item, index, contingencies) {
    item.start = date;
    // console.log("contStartDateChanges date", date);

    contingencies[index] = item;

    let finalInputCont = [];
    for (let i = 0; i < contingencies.length; i++) {
      if (contingencies[i].isActive) {
        if (contingencies[i].assignee !== "") {
          finalInputCont.push({
            name: contingencies[i].key,
            startDate: new Date(contingencies[i].start),
            endDate: new Date(contingencies[i].end),
            assignee: contingencies[i].assignee,
            isParticipant: contingencies[i].isParticipant,
          });
        } else {
          finalInputCont.push({
            name: contingencies[i].key,
            startDate: new Date(contingencies[i].start),
            endDate: new Date(contingencies[i].end),
            isParticipant: contingencies[i].isParticipant,
          });
        }
      }
    }
    // console.log("contStartDateChanges finalInputCont: ", finalInputCont);
    this.contEndDateChanges(date, item, index, contingencies);

    if (this.props.isUpdateTrans) {
      let updatedKeys = item.key;
      this.props.contiCamp(finalInputCont, updatedKeys);
    } else {
      this.props.contiCamp(finalInputCont);
    }
  }

  //Change end date of contingency
  contEndDateChanges(date, item, index, contingencies) {
    item.end = date;
    // console.log("contEndDateChanges date", date);

    contingencies[index] = item;

    let finalInputCont = [];
    for (let i = 0; i < contingencies.length; i++) {
      if (contingencies[i].isActive) {
        if (contingencies[i].assignee !== "") {
          finalInputCont.push({
            name: contingencies[i].key,
            startDate: new Date(contingencies[i].start),
            endDate: contingencies[i].end,
            assignee: contingencies[i].assignee,
            isParticipant: contingencies[i].isParticipant,
          });
        } else {
          finalInputCont.push({
            name: contingencies[i].key,
            startDate: new Date(contingencies[i].start),
            endDate: contingencies[i].end,
            isParticipant: contingencies[i].isParticipant,
          });
        }
      }
    }
    // console.log("contEndDateChanges finalInputCont", finalInputCont);

    this.setDuration(this.state.selectedDuration, item, index, contingencies);

    if (this.props.isUpdateTrans) {
      let updatedKeys = item.key;
      this.props.contiCamp(finalInputCont, updatedKeys);
    } else {
      this.props.contiCamp(finalInputCont);
    }
  }

  contStartTimeChanges(time, item, index, contingencies) {
    item.start = time;
    // console.log("contStartTimeChanges  item.start", item.start);
    // console.log("contStartTimeChanges time", time);
    contingencies[index] = item;

    let finalInputCont = [];
    for (let i = 0; i < contingencies.length; i++) {
      if (contingencies[i].isActive) {
        if (contingencies[i].assignee !== "") {
          finalInputCont.push({
            name: contingencies[i].key,
            startDate: new Date(contingencies[i].start),
            endDate: contingencies[i].end,
            assignee: contingencies[i].assignee,
            isParticipant: contingencies[i].isParticipant,
          });
        } else {
          finalInputCont.push({
            name: contingencies[i].key,
            startDate: new Date(contingencies[i].start),
            endDate: contingencies[i].end,
            isParticipant: contingencies[i].isParticipant,
          });
        }
      }
    }

    // console.log("contStartTimeChanges finalInputCont", finalInputCont);
    this.setDuration(this.state.selectedDuration, item, index, contingencies);

    // if (this.props.isUpdateTrans) {
    //   let updatedKeys = item.key;
    //   this.props.contiCamp(finalInputCont, updatedKeys);
    // } else {
    //   this.props.contiCamp(finalInputCont);
    // }
  }

  contEndTimeChanges(time, item, index, contingencies) {
    item.end = time;
    // console.log("contEndTimeChanges time", time);
    contingencies[index] = item;

    let finalInputCont = [];
    for (let i = 0; i < contingencies.length; i++) {
      if (contingencies[i].isActive) {
        if (contingencies[i].assignee !== "") {
          finalInputCont.push({
            name: contingencies[i].key,
            startDate: new Date(contingencies[i].start),
            endDate: contingencies[i].end,
            assignee: contingencies[i].assignee,
            isParticipant: contingencies[i].isParticipant,
          });
        } else {
          finalInputCont.push({
            name: contingencies[i].key,
            startDate: new Date(contingencies[i].start),
            endDate: contingencies[i].end,
            isParticipant: contingencies[i].isParticipant,
          });
        }
      }
    }
    // console.log("contEndTimeChanges finalInputCont", finalInputCont);

    if (this.props.isUpdateTrans) {
      let updatedKeys = item.key;
      this.props.contiCamp(finalInputCont, updatedKeys);
    } else {
      this.props.contiCamp(finalInputCont);
    }
  }

  setDuration(e, item, index, contingencies) {
    this.setState({ selectedDuration: e });
    // console.log("setDuration e", e);
    let startTime = new Date(item.start);

    // console.log("setDuration startTime", startTime);

    let duration = parseInt(e);
    // console.log("setDuration duration", duration);

    let endTime = new Date(startTime.getTime() + duration * 60000);

    // console.log("setDuration endTime", endTime);

    this.contEndTimeChanges(endTime, item, index, contingencies);
  }

  //Active/Inactive contingency from list
  activeUpContigency(i, index, item, contingencies) {
    let isActive = true;

    if (
      this.props.isUpdateTrans !== undefined &&
      this.props.isUpdateTrans === true
    ) {
      if (i === 1) {
        let c = window.confirm(
          "Deactivating a contingency will delete all the tasks associated with it. Are you sure want to do this?"
        );

        if (!c) {
          return false;
        }
      }
    }

    if (i == 1) {
      isActive = false;
    }

    item.isActive = isActive;
    contingencies[index] = item;

    let finalInputCont = [];
    for (let i = 0; i < contingencies.length; i++) {
      if (contingencies[i].isActive) {
        if (contingencies[i].assignee !== "") {
          finalInputCont.push({
            name: contingencies[i].key,
            startDate: new Date(contingencies[i].start),
            endDate: contingencies[i].end,
            assignee: contingencies[i].assignee,
            isParticipant: contingencies[i].isParticipant,
          });
        } else {
          finalInputCont.push({
            name: contingencies[i].key,
            startDate: new Date(contingencies[i].start),
            endDate: contingencies[i].end,
            isParticipant: contingencies[i].isParticipant,
          });
        }
      }
    }

    if (this.props.isUpdateTrans) {
      let updatedKeys = item.key;
      this.props.contiCamp(finalInputCont, updatedKeys);
    } else {
      this.props.contiCamp(finalInputCont);
    }
  }

  setAssignee(e, item, index, contingencies, fullcontactdata) {
   // console.log("setAssignee calls -- 1408");
    let transData = this.props.getTransactionData();
    let appointmentItem = {};
    let paperworkItem = {};
    // console.log("at setassignee 778")
    if (e === "") {
      item.assignee = this.props.isUpdateTrans ? "" : "no";
      item.itemdefaultAssignee = false;
    } else {
      item.assignee = e;
      item.itemdefaultAssignee = false;
      item.isActive = true;
    }
    if (item.key === "Artist") {
      let found = false;
      let selectedArtist = [];
      // console.log("at artist 790")
      selectedArtist.push({
        firstname: fullcontactdata.UserData[0].firstname,
        lastname: fullcontactdata.UserData[0].lastname,
        mobileNumber: fullcontactdata.UserData[0].mobileNumber,
        email: fullcontactdata.UserData[0].email.address,
        id: fullcontactdata.UserData[0]._id,
        contactId: fullcontactdata._id,
      });
      // console.log("selected Artist",selectedArtist)
      this.setState({ artist: selectedArtist });
      this.props.updateTransactionData("listingAgents", selectedArtist);

      if (this.props.isUpdateTrans && item.key === "Artist") {
        this.props.updateArtistData(selectedArtist, "listingAgents");
      }

      this.setState({ selectedDuration: "60" });

      appointmentItem = {
        assignee: e,
        defaultAssignee: true,
        end: moment()
          .minutes(0)
          .add(1, "hour"),
        isActive: true,
        isParticipant: false,
        itemdefaultAssignee: false,
        key: "First Appointment",
        start: moment().minutes(0),
        val: "First Appointment",
      };
    }
    if (item.key === "Client") {
      let found = false;
      let selectedClient = [];
      let selectedClientId = [];
      // console.log("at client 778")
      selectedClient.push({
        firstname: fullcontactdata.UserData[0].firstname,
        lastname: fullcontactdata.UserData[0].lastname,
        mobileNumber: fullcontactdata.UserData[0].mobileNumber,
        email: fullcontactdata.UserData[0].email.address,
        id: fullcontactdata.UserData[0]._id,
        contactId: fullcontactdata._id,
      });
      selectedClientId.push(fullcontactdata.UserData[0]._id);
      this.setState({ client: selectedClient });
      this.props.updateTransactionData("buyers", selectedClient);

      if (this.props.isUpdateTrans && item.key === "Client") {
        this.props.updateClientData(selectedClient, "buyers");
        this.props.updateClientId(selectedClientId, "buyerId");
      }

      paperworkItem = {
        assignee: e,
        defaultAssignee: true,
        end: item.end,
        isActive: true,
        isParticipant: false,
        itemdefaultAssignee: false,
        key: "Paperwork",
        start: item.start,
        val: "Paperwork",
      };
    }

    if (item.key === "Guardian" && item.isActive === true) {
      let found = false;
      let clientGuardian = [];
      let selectedGuardian = [];

      selectedGuardian.push({
        firstname: fullcontactdata.UserData[0].firstname,
        lastname: fullcontactdata.UserData[0].lastname,
        mobileNumber: fullcontactdata.UserData[0].mobileNumber,
        email: fullcontactdata.UserData[0].email.address,
        id: fullcontactdata.UserData[0]._id,
        contactId: fullcontactdata._id,
      });
      clientGuardian.push(
        {
          firstname: fullcontactdata.UserData[0].firstname,
          lastname: fullcontactdata.UserData[0].lastname,
          mobileNumber: fullcontactdata.UserData[0].mobileNumber,
          email: fullcontactdata.UserData[0].email.address,
          id: fullcontactdata.UserData[0]._id,
          contactId: fullcontactdata._id,
        },
        {
          firstname: fullcontactdata.UserData[0].firstname,
          lastname: fullcontactdata.UserData[0].lastname,
          mobileNumber: fullcontactdata.UserData[0].mobileNumber,
          email: fullcontactdata.UserData[0].email.address,
          id: fullcontactdata.UserData[0]._id,
          contactId: fullcontactdata._id,
        }
      );

      this.setState({ guardian: selectedGuardian });
      // this.props.updateTransactionData("buyers", clientGuardian);
      this.props.updateTransactionData("closingAgents", selectedGuardian);
      if (this.props.isUpdateTrans) {
        this.props.updateGuardianData(selectedGuardian, "closingAgents");
      }
    }

    // if (item.key === "Guardian" && item.isActive === true) {
    //   let found = false;
    //   let clientGuardian = [];
    //   let selectedGuardian = [];
    //   for (let i = 0; this.props.contacts.length; i++) {
    //     if (e === this.props.contacts[i].contactId) {
    //       selectedGuardian.push({
    //         firstname: this.props.contacts[i].firstname,
    //         lastname: this.props.contacts[i].lastname,
    //         mobileNumber: this.props.contacts[i].mobileNumber,
    //         email: this.props.contacts[i].email,
    //         id: this.props.contacts[i]._id,
    //         contactId: this.props.contacts[i].contactId
    //       })
    //       clientGuardian.push(
    //       {
    //         firstname: this.state.client[0].firstname,
    //         lastname: this.state.client[0].lastname,
    //         mobileNumber: this.state.client[0].mobileNumber,
    //         email: this.state.client[0].email,
    //         id: this.state.client[0].id,
    //         contactId: this.state.client[0].contactId
    //       },
    //       {
    //         firstname: this.props.contacts[i].firstname,
    //         lastname: this.props.contacts[i].lastname,
    //         mobileNumber: this.props.contacts[i].mobileNumber,
    //         email: this.props.contacts[i].email,
    //         id: this.props.contacts[i]._id,
    //         contactId: this.props.contacts[i].contactId
    //       })
    //       this.setState({ guardian: selectedGuardian });
    //       console.log("clientGuardian",clientGuardian)
    //       this.props.updateTransactionData("buyers", clientGuardian);
    //       this.props.updateTransactionData("closingAgents", selectedGuardian);
    //       found = true;
    //       break;
    //     }
    //     if (found) {
    //       break;
    //     }
    //     if (this.props.isUpdateTrans && item.key === "Guardian") {
    //       this.props.updateGuardianData(selectedGuardian, "closingAgents");
    //     }
    //   }
    // }

    for (let k = 0; k < contingencies.length; k++) {
      if (
        contingencies[k].key === "First Appointment" &&
        item.key === "Artist"
      ) {
        contingencies[k] = appointmentItem;
      }

      if (contingencies[k].key === "Paperwork" && item.key === "Client") {
        contingencies[k] = paperworkItem;
      }
    }

    contingencies[index] = item;

    let finalInputCont = [];
    for (let i = 0; i < contingencies.length; i++) {
      if (contingencies[i].isActive) {
        if (contingencies[i].assignee !== "") {
          finalInputCont.push({
            name: contingencies[i].key,
            startDate: new Date(contingencies[i].start),
            endDate: new Date(contingencies[i].end),
            assignee: contingencies[i].assignee,
            isParticipant: contingencies[i].isParticipant,
          });
        } else {
          finalInputCont.push({
            name: contingencies[i].key,
            startDate: new Date(contingencies[i].start),
            endDate: new Date(contingencies[i].end),
            isParticipant: contingencies[i].isParticipant,
          });
        }
      }
    }

    // console.log('setAssignee finalInputCont: ', finalInputCont);

    if (this.props.isUpdateTrans) {
      let updatedKeys = item.key;
      this.props.contiCamp(finalInputCont, updatedKeys);
    } else {
      this.props.contiCamp(finalInputCont);
    }
  }

  // setAssignee(e, item, index, contingencies) {

  //   let transData = this.props.getTransactionData();
  //   let appointmentItem = {};
  //   let paperworkItem = {};

  //   if (e === "") {
  //     item.assignee = (this.props.isUpdateTrans) ? "" : "no";
  //     item.itemdefaultAssignee = false;
  //   } else {
  //     item.assignee = e;
  //     item.itemdefaultAssignee = false;
  //     item.isActive = true;
  //   }

  //   if (item.key === "Artist") {
  //     let found = false;
  //     let selectedArtist = [];
  //     for (let i = 0; this.props.contacts.length; i++) {
  //       if (e === this.props.contacts[i].contactId) {
  //         selectedArtist.push({
  //           firstname: this.props.contacts[i].firstname,
  //           lastname: this.props.contacts[i].lastname,
  //           mobileNumber: this.props.contacts[i].mobileNumber,
  //           email: this.props.contacts[i].email,
  //           id: this.props.contacts[i]._id,
  //           contactId: this.props.contacts[i].contactId
  //         })
  //         this.setState({ artist: selectedArtist });
  //         this.props.updateTransactionData("listingAgents", selectedArtist);
  //         found = true;
  //         break;
  //       }
  //       if (found) {
  //         break;
  //       }
  //       if (this.props.isUpdateTrans && item.key === "Artist") {
  //         this.props.updateArtistData(selectedArtist, "listingAgents");
  //       }
  //     }
  //     appointmentItem = {
  //       assignee: e,
  //       defaultAssignee: true,
  //       end: moment().minutes(0).add(1, 'hour'),
  //       isActive: true,
  //       isParticipant: false,
  //       itemdefaultAssignee: false,
  //       key: "First Appointment",
  //       start: moment().minutes(0),
  //       val: "First Appointment"
  //     }
  //   }

  //   if (item.key === "Client") {
  //     let found = false;
  //     let selectedClient = [];
  //     let selectedClientId = [];
  //     for (let i = 0; this.props.contacts.length; i++) {
  //       if (e === this.props.contacts[i].contactId) {
  //         selectedClient.push({
  //           firstname: this.props.contacts[i].firstname,
  //           lastname: this.props.contacts[i].lastname,
  //           mobileNumber: this.props.contacts[i].mobileNumber,
  //           email: this.props.contacts[i].email,
  //           id: this.props.contacts[i]._id,
  //           contactId: this.props.contacts[i].contactId
  //         })
  //         selectedClientId.push(this.props.contacts[i]._id)
  //         this.setState({ client: selectedClient });
  //         this.props.updateTransactionData("buyers", selectedClient);
  //         found = true;
  //         break;
  //       }
  //       if (found) {
  //         break;
  //       }
  //       if (this.props.isUpdateTrans && item.key === "Client") {
  //         this.props.updateClientData(selectedClient, "buyers");
  //         this.props.updateClientId(selectedClientId, "buyerId");
  //       }
  //     }
  //     paperworkItem = {
  //       assignee: e,
  //       defaultAssignee: true,
  //       end: item.end,
  //       isActive: true,
  //       isParticipant: false,
  //       itemdefaultAssignee: false,
  //       key: "Paperwork",
  //       start: item.start,
  //       val: "Paperwork"
  //     }
  //   }

  //   if (item.key === "Guardian" && item.isActive === true) {
  //     let found = false;
  //     let clientGuardian = [];
  //     let selectedGuardian = [];
  //     for (let i = 0; this.props.contacts.length; i++) {
  //       if (e === this.props.contacts[i].contactId) {
  //         selectedGuardian.push({
  //           firstname: this.props.contacts[i].firstname,
  //           lastname: this.props.contacts[i].lastname,
  //           mobileNumber: this.props.contacts[i].mobileNumber,
  //           email: this.props.contacts[i].email,
  //           id: this.props.contacts[i]._id,
  //           contactId: this.props.contacts[i].contactId
  //         })
  //         clientGuardian.push({
  //           firstname: this.props.contacts[i].firstname,
  //           lastname: this.props.contacts[i].lastname,
  //           mobileNumber: this.props.contacts[i].mobileNumber,
  //           email: this.props.contacts[i].email,
  //           id: this.props.contacts[i]._id,
  //           contactId: this.props.contacts[i].contactId
  //         },
  //         {
  //           firstname: this.state.client[0].firstname,
  //           lastname: this.state.client[0].lastname,
  //           mobileNumber: this.state.client[0].mobileNumber,
  //           email: this.state.client[0].email,
  //           id: this.state.client[0].id,
  //           contactId: this.state.client[0].contactId
  //         })
  //         this.setState({ guardian: selectedGuardian });
  //         this.props.updateTransactionData("buyers", clientGuardian);
  //         this.props.updateTransactionData("closingAgents", selectedGuardian);
  //         found = true;
  //         break;
  //       }
  //       if (found) {
  //         break;
  //       }
  //       if (this.props.isUpdateTrans && item.key === "Guardian") {
  //         this.props.updateGuardianData(selectedGuardian, "closingAgents");
  //       }
  //     }
  //   }

  //   for (let k = 0; k < contingencies.length; k++) {
  //     if (contingencies[k].key === "First Appointment" && item.key === "Artist") {
  //       contingencies[k] = appointmentItem;
  //     }

  //     if (contingencies[k].key === "Paperwork" && item.key === "Client") {
  //       contingencies[k] = paperworkItem;
  //     }
  //   }

  //   contingencies[index] = item;

  //   let finalInputCont = [];
  //   for (let i = 0; i < contingencies.length; i++) {
  //     if (contingencies[i].isActive) {

  //       if (contingencies[i].assignee !== "") {
  //         finalInputCont.push({
  //           name: contingencies[i].key,
  //           startDate: new Date(contingencies[i].start),
  //           endDate: new Date(contingencies[i].end),
  //           assignee: contingencies[i].assignee,
  //           isParticipant: contingencies[i].isParticipant
  //         })
  //       } else {
  //         finalInputCont.push({
  //           name: contingencies[i].key,
  //           startDate: new Date(contingencies[i].start),
  //           endDate: new Date(contingencies[i].end),
  //           isParticipant: contingencies[i].isParticipant
  //         })
  //       }

  //     }
  //   }

  //   if (this.props.isUpdateTrans) {
  //     let updatedKeys = item.key;
  //     this.props.contiCamp(finalInputCont, updatedKeys)
  //   } else {
  //     this.props.contiCamp(finalInputCont)
  //   }
  // }

  /**
   * @desc event on pressing enter - add custom contigency
   * @param {*} e
   * @param {*} contingencies
   */
  enterCustomTranContingency(e, contingencies) {
    let newConti = $(".set-contingencies-footer .title input").val() || "";

    if (newConti !== "" && newConti != null) {
      contingencies.push({
        key: newConti,
        val: newConti,
        isActive: true,
        start: this.state.contStartDate.format("YYYY-MM-DD"),
        end: this.state.contEndDate.format("YYYY-MM-DD"),
        assignee: "no",
      });
      let finalInputCont = [];
      for (let i = 0; i < contingencies.length; i++) {
        if (contingencies[i].isActive) {
          if (contingencies[i].assignee !== "") {
            finalInputCont.push({
              name: contingencies[i].key,
              startDate: new Date(contingencies[i].start),
              endDate: new Date(contingencies[i].end),
              assignee: contingencies[i].assignee,
              isParticipant: contingencies[i].isParticipant,
            });
          } else {
            finalInputCont.push({
              name: contingencies[i].key,
              startDate: new Date(contingencies[i].start),
              endDate: new Date(contingencies[i].end),
              isParticipant: contingencies[i].isParticipant,
            });
          }
        }
      }
      $(".set-contingencies-footer .title input").val("");

      if (this.props.isUpdateTrans) {
        let updatedKeys = newConti;
        this.props.contiCamp(finalInputCont, updatedKeys);
      } else {
        this.props.contiCamp(finalInputCont);
      }
    }
  }

  /**
   * @desc add custom contigency
   * @param {*} e
   * @param {*} contingencies
   */
  addCustomTranContingency(e, contingencies) {
    let newConti = "";
    if (e.key === "Enter" && e.shiftKey === true) {
      newConti = e.target.value;
    } else if (e.key === "Enter" && e.shiftKey === false) {
      newConti = e.target.value;
    }

    if (newConti !== "" && newConti !== null) {
      let isContiExist = false;
      for (let i = 0; i < contingencies.length; i++) {
        if (contingencies[i].key.toUpperCase() === newConti.toUpperCase()) {
          isContiExist = true;
        }
      }

      this.setState({ isContiExist });

      if (!isContiExist) {
        contingencies.push({
          key: newConti,
          val: newConti,
          isActive: true,
          isParticipant: false,
          start: this.state.contStartDate.format("YYYY-MM-DD"),
          end: this.state.contEndDate.format("YYYY-MM-DD"),
          assignee: "no",
        });
        let finalInputCont = [];
        for (let i = 0; i < contingencies.length; i++) {
          if (contingencies[i].isActive) {
            if (contingencies[i].assignee !== "") {
              finalInputCont.push({
                name: contingencies[i].key,
                startDate: new Date(contingencies[i].start),
                endDate: new Date(contingencies[i].end),
                assignee: contingencies[i].assignee,
                isParticipant: contingencies[i].isParticipant,
              });
            } else {
              finalInputCont.push({
                name: contingencies[i].key,
                startDate: new Date(contingencies[i].start),
                endDate: new Date(contingencies[i].end),
                isParticipant: contingencies[i].isParticipant,
              });
            }
          }
        }
        e.target.value = "";

        if (this.props.isUpdateTrans) {
          let updatedKeys = newConti;
          this.props.contiCamp(finalInputCont, updatedKeys);
        } else {
          this.props.contiCamp(finalInputCont);
        }
      }
    }
  }

  /**
   * @desc add custom participant
   * @param {*} e
   * @param {*} contingencies
   */
  addCustomParticipant(e, contingencies) {
    let newConti = "";
    if (e.key === "Enter" && e.shiftKey === true) {
      newConti = e.target.value;
    } else if (e.key === "Enter" && e.shiftKey === false) {
      newConti = e.target.value;
    }

    if (newConti !== "" && newConti !== null) {
      let isContiExist = false;
      for (let i = 0; i < contingencies.length; i++) {
        if (contingencies[i].key.toUpperCase() === newConti.toUpperCase()) {
          isContiExist = true;
        }
      }

      this.setState({ isContiExist });

      if (!isContiExist) {
        contingencies.push({
          key: newConti,
          val: newConti,
          isActive: true,
          isParticipant: true,
          start: this.state.contStartDate.format("YYYY-MM-DD"),
          end: this.state.contEndDate.format("YYYY-MM-DD"),
          assignee: "no",
        });
        let finalInputCont = [];
        for (let i = 0; i < contingencies.length; i++) {
          if (contingencies[i].isActive) {
            if (contingencies[i].assignee !== "") {
              finalInputCont.push({
                name: contingencies[i].key,
                startDate: new Date(contingencies[i].start),
                endDate: new Date(contingencies[i].end),
                assignee: contingencies[i].assignee,
                isParticipant: contingencies[i].isParticipant,
              });
            } else {
              finalInputCont.push({
                name: contingencies[i].key,
                startDate: new Date(contingencies[i].start),
                endDate: new Date(contingencies[i].end),
                isParticipant: contingencies[i].isParticipant,
              });
            }
          }
        }
        e.target.value = "";

        if (this.props.isUpdateTrans) {
          let updatedKeys = newConti;
          this.props.contiCamp(finalInputCont, updatedKeys);
        } else {
          this.props.contiCamp(finalInputCont);
        }
      }
    }
  }

  /**
   * @desc set vendor options list
   * @param {*} conti
   * @param {*} item
   * @param {*} index
   * @param {*} contingencies
   */
  listVendorsByConti(conti, item, index, contingencies) {
    let transcationAllData = this.props.getTransactionData();

    let vendors = this.state.vendors;
    let filteredVendors = [];

    //added filter for contingency
    if (vendors["all"] !== undefined && vendors["all"] !== null) {
      let vendorsData =
        vendors["all"].data !== undefined && vendors["all"].data !== null
          ? vendors["all"].data
          : [];
      for (let i = 0, len = vendorsData.length; i < len; i++) {
        filteredVendors.push({
          role: vendorsData[i].roles,
          key: vendorsData[i].contactId,
          name:
            vendorsData[i].firstname +
            " " +
            (vendorsData[i].lastname ? vendorsData[i].lastname : ""),
          value: vendorsData[i].contactId,
          isDeletedVendor: vendorsData[i].isDeletedVendor,
        });
      }
    }
    // console.log("this.state.userType", this.state.currentRole);
    // Buyer agent added to options
    if (
      this.state.userType == message.ACCTOWNER ||
      this.state.userType == message.VENDOR
    ) {
      filteredVendors.push({
        role: "",
        key: localStorage.getItem("ID"),
        name:
          localStorage.getItem("fname") + " " + localStorage.getItem("lname"),
        value: localStorage.getItem("ID"),
        isDeletedVendor: false,
      });
    }

    if (
      this.state.userType === message.BUYER ||
      this.state.currentRole === message.BUYER ||
      (this.state.userType === message.VENDOR &&
        this.state.currentRole === message.VENDOR)
    ) {
      if (item.isActive) {
        var name = "";
        var contactId = "";
        for (let k = 0; k < this.state.buyerVendors.length; k++) {
          if (this.state.buyerVendors[k]._id == item.assignee) {
            name =
              this.state.buyerVendors[k].firstname +
              " " +
              this.state.buyerVendors[k].lastname;
            contactId = this.state.buyerVendors[k].contactId;
            break;
          }
        }
      }

      return (
        <div>
          {item.isActive ? (
            <>
              {name != "" ? (
                // <Link
                //   to={"/UserProfile/" + contactId}
                //   className="text-capitalize font-500 color-dark-blue c-pointer font-14"
                // >
                //   {name}
                // </Link>
                <input value={name} readOnly={true} />
              ) : (
                <div className="font-14">No Contact Selected</div>
              )}
            </>
          ) : (
            ""
          )}
        </div>
      );
    } else {
      var ucontactId = "";

      if (ucontactId == "") {
        if (vendors["all"] !== undefined && vendors["all"] !== null) {
          for (let ik = 0; ik < vendors["all"].data.length; ik++) {
            if (vendors["all"].data[ik].contactId == item.assignee) {
              ucontactId = vendors["all"].data[ik]._id;
              break;
            }
          }
        }
      }

      //if assignee is not selected then check days gaps for setting border color
      //2 days, yellow, 5 days, orange, 10 days red - Client feedback
      let days = this.contiDaysDiff();
      let color =
        this.props.transStatus != "COMPLETED" &&
        item.isActive &&
        ucontactId == ""
          ? days >= 10
            ? "red"
            : days >= 5
            ? "orange"
            : days >= 2
            ? "yellow"
            : "#c8c8c8"
          : "#c8c8c8";
      // console.log("item====>",item)
      // console.log("conti====>",conti)
      // console.log("index====>",index)
      // console.log("contingencies====>",contingencies)
      // console.log("filteredVendors====>",filteredVendors)
      // console.log("item.assignee====>",item.assignee)
      let abc = filteredVendors.filter(
        (element) => element.key == item.assignee
      );
      let value = "";
      let valueId = "";
      if (abc.length > 0) {
        // console.log("abc=====>",abc[0].name)
        value = abc[0].name;
        valueId = abc[0].key;
      }
      // console.log("=========this.props.transStatus===========>",this.props.transStatus)
      return (
        <Row>
          <div className="d-flex">
            <input value={value} readOnly={true} />
            {item.isActive &&
            (this.props.transStatus == "INPROGRESS" ||
              this.props.transStatus == undefined) ? (
              this.state.userType === message.BUYER ||
              this.state.currentRole == message.BUYER ||
              (this.state.userType === message.VENDOR &&
                this.state.currentRole == message.Artist &&
                !this.checkPermission([message.manage_transactions])) ? (
                ""
              ) : (
                <Button
                  variant="transparent"
                  className="p-0"
                  onClick={() =>
                    this.setModalOpen1(item.key, value, valueId, {
                      e: valueId,
                      item: item,
                      key: item.key,
                      contingencies: contingencies,
                    })
                  }
                >
                  <Edit fontSize="small" />
                </Button>
              )
            ) : (
              ""
            )}
          </div>
        </Row>
      );
    }
  }

  fuzzySearch(filteredVendors) {
    const fuse = new Fuse(filteredVendors, {
      keys: ["name"],
      threshold: 0.3,
    });

    return (value) => {
      if (!value.length) {
        return filteredVendors;
      }

      return fuse.search(value).map(({ item }) => item);
    };
  }

  contiDaysDiff() {
    let transcationAllData = this.props.getTransactionData();
    let startdate = moment(transcationAllData.startDate);
    let now = moment(new Date());
    let duration = moment.duration(now.diff(startdate));
    let days = duration.asDays();
    return days.toFixed(2);
  }

  render() {
    // let isActive = localStorage.getItem("isActive");
    // console.log(
    //   "this.checkPermission",
    //   this.checkPermission([message.manage_transactions])
    // );
    let selectedCampContis = {};
    if (!!this.props.campaignStyle) {
      for (let i = 0, len = this.props.campaignStyle.length; i < len; i++) {
        if (
          this.props.getTransactionData().campaign ===
          this.props.campaignStyle[i]._id
        ) {
          selectedCampContis = this.props.campaignStyle[i].contingencies;
        }
      }
    }

    let allContingenciesFromAPI = this.state.allContingenciesFromAPI;

    if (!!selectedCampContis && Object.keys(selectedCampContis).length !== 0) {
      for (let key in selectedCampContis) {
        if (selectedCampContis.hasOwnProperty(key)) {
          let f = false;
          allContingenciesFromAPI.forEach((ele) => {
            if (ele.name == key) {
              f = true;
            }
          });
          if (!f) {
            allContingenciesFromAPI.push({ name: key, date: key });
          }
        }
      }
    }

    let transcationAllData = this.props.getTransactionData();
    // console.log("transcationAllData", transcationAllData);
    let contingencies = [];
    for (let key in this.props.campContingencies) {
      //set contigency with details in array with related data
      let v = this.props.campContingencies[key];

      if (
        v.name === "First Appointment" &&
        transcationAllData.listingAgents.length !== 0
      ) {
        contingencies.push({
          key: v.name,
          val: v.name,
          isActive: true,
          isParticipant: v.isParticipant,
          start:
            v.startDate != ""
              ? v.startDate
              : this.props.isUpdateTrans
              ? this.props.transdata.startDate
              : this.state.contStartDate.format("YYYY-MM-DD"),
          end:
            v.endDate != ""
              ? v.endDate
              : this.props.isUpdateTrans
              ? this.props.transdata.endDate
              : this.state.contEndDate.format("YYYY-MM-DD"),
          assignee: transcationAllData.listingAgents[0].contactId,
          defaultAssignee:
            v.assignee !== "" && v.assignee !== undefined ? false : true,
        });
      } else if (
        v.name === "Paperwork" &&
        transcationAllData.buyers.length !== 0
      ) {
        contingencies.push({
          key: v.name,
          val: v.name,
          isActive: true,
          isParticipant: v.isParticipant,
          start:
            v.startDate != ""
              ? v.startDate
              : this.props.isUpdateTrans
              ? this.props.transdata.startDate
              : this.state.contStartDate.format("YYYY-MM-DD"),
          end:
            v.endDate != ""
              ? v.endDate
              : this.props.isUpdateTrans
              ? this.props.transdata.endDate
              : this.state.contEndDate.format("YYYY-MM-DD"),
          assignee: transcationAllData.buyers[0].contactId,
          defaultAssignee:
            v.assignee !== "" && v.assignee !== undefined ? false : true,
        });
      } else {
        contingencies.push({
          key: v.name,
          val: v.name,
          isActive: true,
          isParticipant: v.isParticipant,
          start:
            v.startDate != ""
              ? v.startDate
              : this.props.isUpdateTrans
              ? this.props.transdata.startDate
              : this.state.contStartDate.format("YYYY-MM-DD"),
          end:
            v.endDate != ""
              ? v.endDate
              : this.props.isUpdateTrans
              ? this.props.transdata.endDate
              : this.state.contEndDate.format("YYYY-MM-DD"),
          assignee: v.assignee,
          defaultAssignee:
            v.assignee !== "" && v.assignee !== undefined ? false : true,
        });
      }
    }

    allContingenciesFromAPI.forEach((ele) => {
      var found = false;
      for (let key in this.props.campContingencies) {
        if (ele.name == this.props.campContingencies[key].name) {
          found = true;
        }
      }
      if (!found) {
        contingencies.push({
          key: ele.name,
          val: ele.date,
          isActive: false,
          isParticipant: ele.isParticipant,
          start: this.state.contStartDate.format("YYYY-MM-DD"),
          end: this.props.isUpdateTrans
            ? this.props.transdata.endDate
            : this.state.contEndDate.format("YYYY-MM-DD"),
          assignee: "",
          defaultAssignee: false,
        });
      }
    });

    let minsDate = moment().format("YYYY-MM-DD");

    if (this.props.isUpdateTrans) {
      if (
        this.props.startDate !== undefined &&
        this.props.startDate !== "" &&
        this.props.startDate !== null
      ) {
        minsDate = moment(this.props.startDate).format("YYYY-MM-DD");
      }
    } else {
      let miDate = moment(transcationAllData.startDate);
      minsDate = miDate.format("YYYY-MM-DD");
    }

    contingencies = _.orderBy(
      contingencies,
      ["isActive", "key"],
      ["desc", "asc"]
    );
    // console.log("render contingency ", contingencies);
    // console.log("value===>",this.state.value)
    return (
      <div>
        {this.state.showLoader && (
          <div className="page-loader fixed">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        )}

        <Row className="mt-2 align-items-center conti-title">
          <Col className="col-auto pr-0">
            <h2 className="color-black font-20 mb-0">Important People</h2>
          </Col>
          {this.state.userType === message.BUYER ||
          this.state.currentRole == message.BUYER ||
          (this.state.userType === message.VENDOR &&
            this.state.currentRole == message.Artist &&
            !this.checkPermission([message.manage_transactions])) ||
          (this.state.userType === message.VENDOR &&
            this.state.currentRole == message.BUYER) ||
          (this.props.transdata && this.props.transStatus === "COMPLETED") ? (
            ""
          ) : (
            <Col align="right" className="pl-0">
              <Button
                variant="primary"
                className="btn-blue text-uppercase add-vendor-btn"
                onClick={() => {
                  // if (isActive === "false") {
                  //   toastMessage(code.ERROR, message.SUBSCRIPTION_NOT_ACTIVE);
                  // } else {
                  //   this.setState({ isVendorClick: true });
                  //   this.addVendor();
                  // }

                  this.addVendor();
                }}
              >
                Add Client
              </Button>
            </Col>
          )}
        </Row>

        <div className="set-contingencies mb-5">
          <div className="set-contingencies-header">
            <ul className="set-contingencies-row">
              <li className="id" />
              <li className="status">Active/Inactive</li>
              <li className="title">Name</li>
              <li className="assign">Assign</li>
            </ul>
          </div>
          <div className="set-contingencies-body">
            <DragDropContext onDragEnd={this.onDragEnd}>
              <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver)}
                  >
                    {contingencies
                      .filter((contingencies) => {
                        let active = false;
                        if (
                          this.state.userType === message.BUYER ||
                          this.state.currentRole === message.BUYER ||
                          (this.state.userType === message.VENDOR &&
                            this.state.currentRole === message.Artist)
                        ) {
                          active =
                            contingencies.isParticipant === true &&
                            contingencies.isActive === true;
                        } else {
                          active = contingencies.isParticipant === true;
                        }
                        return active;
                      })
                      .map((item, index) => (
                        <Draggable
                          key={index}
                          draggableId={"draggableId" + index}
                          index={index}
                          isDragDisabled={true}
                        >
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={getItemStyle(
                                snapshot.isDragging,
                                provided.draggableProps.style
                              )}
                            >
                              <ul
                                className={
                                  item.isActive
                                    ? " set-contingencies-row"
                                    : "inactive set-contingencies-row"
                                }
                              >
                                {item.isActive}
                                <li className="id">
                                  <DragIndicator />
                                </li>
                                <li className="status">
                                  <Button
                                    variant="transparent"
                                    className={
                                      this.state.userType == message.BUYER ||
                                      this.state.currentRole == message.BUYER ||
                                      (this.state.userType == message.VENDOR &&
                                        this.state.currentRole ==
                                          message.Artist &&
                                        !this.checkPermission([
                                          message.manage_transactions,
                                        ])) ||
                                      (this.props.isUpdateTrans &&
                                        this.props.transStatus == "COMPLETED")
                                        ? "pointer-none"
                                        : ""
                                    }
                                  >
                                    {item.isActive ? (
                                      <CheckCircle
                                        className="check"
                                        onClick={() =>
                                          this.activeUpContigency(
                                            1,
                                            item.key,
                                            item,
                                            contingencies
                                          )
                                        }
                                      />
                                    ) : (
                                      <CheckCircleOutline
                                        className="check-out"
                                        onClick={() =>
                                          this.activeUpContigency(
                                            0,
                                            item.key,
                                            item,
                                            contingencies
                                          )
                                        }
                                      />
                                    )}
                                  </Button>
                                </li>
                                <li className="title">{item.key}</li>

                                <li className="assign">
                                  {this.listVendorsByConti(
                                    item.key,
                                    item,
                                    item.key,
                                    contingencies
                                  )}
                                </li>
                              </ul>
                            </div>
                          )}
                        </Draggable>
                      ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>

            <div className="set-contingencies-footer">
              {((this.state.userType === message.ACCTOWNER &&
                this.state.currentRole === message.ACCTOWNER) ||
                (this.state.userType === message.VENDOR &&
                  this.state.currentRole === message.BUYERAGENT) ||
                this.state.userType === message.ADMIN) &&
                (!this.props.isUpdateTrans ||
                  (this.props.transdata &&
                    this.props.transStatus !== "COMPLETED")) && (
                  <ul className="set-contingencies-row">
                    <li className="id" />
                    <li className="status" />
                    <li className="title">
                      <input
                        type="text"
                        onKeyDown={(e) =>
                          this.addCustomParticipant(e, contingencies)
                        }
                        onChange={(e) => {
                          this.setState({ isContiExist: false });
                        }}
                        className="form-control form-control-sm field_ucfirst"
                        placeholder="Add a custom Important Person"
                      />

                      {this.state.isContiExist && (
                        <div
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        >
                          This name is taken. Pick a different one, please.
                        </div>
                      )}
                    </li>
                  </ul>
                )}
            </div>
          </div>
        </div>

        {this.props.transStatus === "INPROGRESS" ? (
          <Tasks
            transactionId={this.props.transID}
            transactionData={this.props.transdata}
            transactionStatus={this.props.transStatus}
          />
        ) : (
          <>
            <Row className="mt-2 align-items-center conti-title">
              <Col className="col-auto pr-0">
                <h2 className="color-black font-20 mb-0">Important Things</h2>
              </Col>
            </Row>
            <div className="set-contingencies mb-5">
              <div className="set-contingencies-header">
                <ul className="set-contingencies-row">
                  <li className="id" />
                  <li className="title">Name</li>
                  <li className="date">Date</li>
                  <li className="date">Time</li>
                  <li className="date">Duration</li>
                </ul>
              </div>
              <div className="set-contingencies-body">
                <DragDropContext onDragEnd={this.onDragEnd}>
                  <Droppable droppableId="droppable">
                    {(provided, snapshot) => (
                      <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        style={getListStyle(snapshot.isDraggingOver)}
                      >
                        {contingencies
                          .filter((contingencies) => {
                            let active = true;
                            if (
                              this.state.userType === message.VENDOR ||
                              this.state.currentRole === message.BUYER ||
                              (this.state.userType === message.VENDOR &&
                                this.state.currentRole === message.Artist)
                            ) {
                              active =
                                contingencies.isParticipant === false &&
                                contingencies.isActive === true;
                            } else {
                              active = contingencies.isParticipant === false;
                            }
                            return active;
                          })
                          .map((item, index) => (
                            <Draggable
                              key={index}
                              draggableId={"draggableId" + index}
                              index={index}
                              isDragDisabled={true}
                            >
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={getItemStyle(
                                    snapshot.isDragging,
                                    provided.draggableProps.style
                                  )}
                                >
                                  <ul
                                    className={
                                      item.isActive
                                        ? " set-contingencies-row"
                                        : "inactive set-contingencies-row"
                                    }
                                  >
                                    {item.isActive}
                                    <li className="id">
                                      <DragIndicator />
                                    </li>
                                    <li className="title">{item.key}</li>

                                    <li className="date">
                                      {item.isActive ? (
                                        <DatePicker
                                          selected={
                                            !!item.start
                                              ? new Date(item.start)
                                              : ""
                                          }
                                          minDate={new Date()}
                                          onChange={(date) =>
                                            this.contStartDateChanges(
                                              date,
                                              item,
                                              item.key,
                                              contingencies
                                            )
                                          }
                                          disabled={
                                            this.state.userType ==
                                              message.BUYER ||
                                            this.state.currentRole ==
                                              message.BUYER ||
                                            (this.state.userType ==
                                              message.VENDOR &&
                                              this.state.currentRole ==
                                                message.Artist &&
                                              !this.checkPermission([
                                                message.manage_transactions,
                                              ])) ||
                                            (this.props.isUpdateTrans &&
                                              this.props.transStatus ==
                                                "COMPLETED") ||
                                            (this.props.isUpdateTrans &&
                                              this.props.transStatus ==
                                                "CANCELED")
                                              ? true
                                              : false
                                          }
                                          dateFormat="MM-d-yyyy"
                                          className="form-control form-control-date pl-1 date-picker"
                                          popperPlacement="left-end"
                                        />
                                      ) : (
                                        <DatePicker
                                          onChange={(date) =>
                                            this.contStartDateChanges(
                                              date,
                                              item,
                                              item.key,
                                              contingencies
                                            )
                                          }
                                          minDate={new Date()}
                                          disabled={
                                            this.state.userType ==
                                              message.BUYER ||
                                            this.state.currentRole ==
                                              message.BUYER ||
                                            (this.state.userType ==
                                              message.VENDOR &&
                                              this.state.currentRole ==
                                                message.VENDOR) ||
                                            (this.props.isUpdateTrans &&
                                              this.props.transStatus ==
                                                "COMPLETED") ||
                                            (this.props.isUpdateTrans &&
                                              this.props.transStatus ==
                                                "CANCELED")
                                              ? true
                                              : false
                                          }
                                        />
                                      )}
                                    </li>

                                    <li className="date">
                                      {item.isActive &&
                                      item.key.includes("Appointment") ? (
                                        <DatePicker
                                          selected={
                                            !!item.start
                                              ? new Date(item.start)
                                              : ""
                                          }
                                          minDate={new Date()}
                                          onChange={(time) =>
                                            this.contStartTimeChanges(
                                              time,
                                              item,
                                              item.key,
                                              contingencies
                                            )
                                          }
                                          showTimeSelect
                                          showTimeSelectOnly
                                          // minTime={
                                          //   new Date(
                                          //     new Date().setHours(8, 0, 0, 0)
                                          //   )
                                          // }
                                          // maxTime={
                                          //   new Date(
                                          //     new Date().setHours(21, 0, 0, 0)
                                          //   )
                                          // }
                                          timeIntervals={15}
                                          timeCaption="Time"
                                          dateFormat="h:mm aa"
                                          className="form-control time-task form-control-date pl-1"
                                          disabled={
                                            this.state.userType ==
                                              message.BUYER ||
                                            this.state.currentRole ==
                                              message.BUYER ||
                                            (this.state.userType ==
                                              message.VENDOR &&
                                              this.state.currentRole ==
                                                message.VENDOR) ||
                                            (this.props.isUpdateTrans &&
                                              this.props.transStatus ==
                                                "COMPLETED") ||
                                            (this.props.isUpdateTrans &&
                                              this.props.transStatus ==
                                                "CANCELED")
                                              ? true
                                              : false
                                          }
                                        />
                                      ) : (
                                        ""
                                      )}
                                    </li>

                                    <li className="date">
                                      {item.isActive &&
                                      item.key.includes("Appointment") ? (
                                        <select
                                          className="form-control form-control-sm"
                                          onChange={(e) =>
                                            this.setDuration(
                                              e.target.value,
                                              item,
                                              item.key,
                                              contingencies
                                            )
                                          }
                                          value={this.state.selectedDuration}
                                          disabled={
                                            this.state.userType ==
                                              message.BUYER ||
                                            this.state.currentRole ==
                                              message.BUYER ||
                                            (this.state.userType ==
                                              message.VENDOR &&
                                              this.state.currentRole ==
                                                message.VENDOR) ||
                                            (this.props.isUpdateTrans &&
                                              this.props.transStatus ==
                                                "COMPLETED") ||
                                            (this.props.isUpdateTrans &&
                                              this.props.transStatus ==
                                                "CANCELED")
                                              ? true
                                              : false
                                          }
                                        >
                                          <option value={15}>15 minutes</option>
                                          <option value={20}>20 minutes</option>
                                          <option value={30}>30 minutes</option>
                                          <option value={45}>45 minutes</option>
                                          <option value={60}>1 hour</option>
                                          <option value={120}>2 hours</option>
                                          <option value={180}>3 hours</option>
                                          <option value={240}>4 hours</option>
                                        </select>
                                      ) : (
                                        ""
                                      )}
                                    </li>
                                  </ul>
                                </div>
                              )}
                            </Draggable>
                          ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
                <div className="set-contingencies-footer">
                  {((this.state.userType === message.ACCTOWNER &&
                    this.state.currentRole === message.ACCTOWNER) ||
                    (this.state.userType === message.VENDOR &&
                      this.state.currentRole === message.BUYERAGENT) ||
                    this.state.userType === message.ADMIN) &&
                    (!this.props.isUpdateTrans ||
                      (this.props.transdata &&
                        this.props.transStatus !== "COMPLETED")) && (
                      <ul className="set-contingencies-row">
                        <li className="id" />
                        <li className="status" />
                        <li className="title">
                          <input
                            type="text"
                            onKeyDown={(e) =>
                              this.addCustomTranContingency(e, contingencies)
                            }
                            onChange={(e) => {
                              this.setState({ isContiExist: false });
                            }}
                            className="form-control form-control-sm field_ucfirst"
                            placeholder="Add a custom Important Thing"
                          />

                          {this.state.isContiExist && (
                            <div
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            >
                              This name is taken. Pick a different one, please.
                            </div>
                          )}
                        </li>
                      </ul>
                    )}
                </div>
              </div>
            </div>
          </>
        )}

        <Modal
          show={this.state.addVendor}
          onHide={() => this.addVendor()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Create New Client
            </Modal.Title>
          </Modal.Header>
          <AddContact
            transactionData={this.props.transdata}
            roleForPopup={"Client"}
            onClose={() => {
              this.setState({ isVendorClick: false });
              this.addCloseVendor(contingencies);
            }}
          />
        </Modal>

        <Modal
          show={this.state.show1}
          onHide={() => this.setModalOpen1()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className={
            this.state.roleForGaurdian == "Artist"
              ? "modal-med modal-art-deta"
              : "modal-med modal-art-deta modal-560"
          }
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Select {this.state.roleForGaurdian}
              <h6 style={{ color: "Green" }}>{this.state.value}</h6>
            </Modal.Title>
          </Modal.Header>
          <SelectClientOrArtist
            DataOfChild={this.DataOfChild}
            role={this.state.role}
            previousData={this.state.dataOfChild}
          />
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allContingencies: state.reducer.allContingencies,
    contactResponse: state.reducer.contactResponse,
    contacts: state.reducer.contacts,
    roles: state.reducer.roles,
    vendorTransactions: state.reducer.vendorTransactions,
  };
};

export default connect(
  mapStateToProps,
  {
    getAllContigencyAction,
    getContactsActions,
    getUserRolesAction,
    getVendorTransactionsAction,
    getallpermissions,
    getContactsActionsByTransactionid,
    getContactsActionsByContactid,
  }
)(UpdateContingencies);
